import type { IconProps } from './types'

export const InventoryIcon = ({ className }: IconProps) => {
  return (
    <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
      <path
        d="M4.75 8.25L12 4.5L19.25 8.25M4.75 8.25V15.75L12 19.5M4.75 8.25L12 12M19.25 8.25V15.75L12 19.5M19.25 8.25L12 12M12 12V19.5"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
    </svg>
  )
}
